import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonBase,
  Divider,
  List,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { isBrowser } from 'react-device-detect';
import { useTranslation } from "react-i18next";
import { useInfoStore } from "../../../store/userInfo";
import { toast } from "react-toastify";
import { logger } from "../../../utils/logger";
import debounce from "lodash/debounce";
import { IDetail, IModifier, IModifierGroup, IOrderModifiers } from "../../../types/menu";
import {ExpandMore, TurnLeft} from '@mui/icons-material';
import { getNestModifierGroup } from "../../../services/order.service";
import { useOrderStore } from "../../../store/order";

var _ = require("lodash");

const MinusIcon = ({ fill, onClick }: { fill: string; onClick: () => void  }) => (
  <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer", width: "26px", height: "26px", maxWidth: "100%" }} onClick={onClick}>
  <g id="minus (1)" clipPath="url(#clip0_7063_8880)">
  <g id="Group">
  <g id="Group_2">
  <path id="Vector" d="M15 0C6.72967 0 0 6.7285 0 15C0 23.2715 6.72967 30 15 30C23.2715 30 30 23.2715 30 15C30 6.7285 23.2703 0 15 0ZM15 27.6762C8.01006 27.6762 2.32377 21.9899 2.32377 15C2.32377 8.01006 8.01006 2.32377 15 2.32377C21.9899 2.32377 27.6762 8.01006 27.6762 15C27.6762 21.9899 21.9899 27.6762 15 27.6762Z" fill={fill}/>
  </g>
  </g>
  <g id="Group_3">
  <g id="Group_4">
  <path id="Vector_2" d="M20.8091 13.7334H9.19023C8.54887 13.7334 8.02832 14.2539 8.02832 14.8953C8.02832 15.5367 8.54887 16.0572 9.19023 16.0572H20.8091C21.4505 16.0572 21.9711 15.5367 21.9711 14.8953C21.9711 14.2539 21.4505 13.7334 20.8091 13.7334Z" fill={fill}/>
  </g>
  </g>
  </g>
  <defs>
  <clipPath id="clip0_7063_8880">
  <rect width="30" height="30" fill="white"/>
  </clipPath>
  </defs>
  </svg>
);

const AddIcon = ({ fill, onClick }: { fill: string; onClick: () => void  }) => (
  <svg width="26" height="26" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer", width: "26px", height: "26px", maxWidth: "100%" }} onClick={onClick}>
  <g id="add (2)" clipPath="url(#clip0_7063_8888)">
  <g id="Group">
  <g id="Group_2">
  <path id="Vector" d="M15 0C6.7285 0 0 6.7285 0 15C0 23.2715 6.7285 30 15 30C23.2715 30 30 23.2703 30 15C30 6.72967 23.2715 0 15 0ZM15 27.6762C8.01123 27.6762 2.32377 21.9899 2.32377 15C2.32377 8.01006 8.01123 2.32377 15 2.32377C21.9888 2.32377 27.6762 8.01006 27.6762 15C27.6762 21.9899 21.9899 27.6762 15 27.6762Z" fill={fill}/>
  </g>
  </g>
  <g id="Group_3">
  <g id="Group_4">
  <path id="Vector_2" d="M20.8091 13.7333H16.1616V9.08574C16.1616 8.44437 15.6422 7.92383 14.9997 7.92383C14.3571 7.92383 13.8378 8.44437 13.8378 9.08574V13.7333H9.19023C8.5477 13.7333 8.02832 14.2538 8.02832 14.8952C8.02832 15.5366 8.5477 16.0571 9.19023 16.0571H13.8378V20.7047C13.8378 21.346 14.3571 21.8666 14.9997 21.8666C15.6422 21.8666 16.1616 21.346 16.1616 20.7047V16.0571H20.8091C21.4517 16.0571 21.9711 15.5366 21.9711 14.8952C21.9711 14.2538 21.4517 13.7333 20.8091 13.7333Z" fill={fill}/>
  </g>
  </g>
  </g>
  <defs>
  <clipPath id="clip0_7063_8888">
  <rect width="30" height="30" fill="white"/>
  </clipPath>
  </defs>
  </svg>
);




const Modifier = (props: { recommendItem: IDetail; setRecommendItem:any; setSelectRequired: any, checkedModifierPrice: any }) => {
  const { recommendItem, setRecommendItem, setSelectRequired, checkedModifierPrice } = props;
  const { userInfo, currentLng } = useInfoStore();
  const { preRecommendOrder, setPreRecommendOrder } = useOrderStore();
  const storeId = userInfo?.storeId;
  const {t} =  useTranslation(`${storeId}`)
  // const [modifierGroups, setModifierGroups] = useState(recommendItem?.modifierGroups || []);

  // useEffect(() => {
  //   console.log("reload", recommendItem)
  //   setModifierGroups(recommendItem?.modifierGroups || [])
  // },[recommendItem])modifierGroups

  useEffect(() => {
    const checkAllRequiredSatisfied = (groups: IModifierGroup[]): boolean => {
      if (!groups || groups.length === 0) return true;

      for (const group of groups) {
        if (!group.modifiers) continue;

        // 현재 그룹의 선택된 수량 계산
        const currentGroupQuantity = group.modifiers.reduce(
          (sum: number, mod: any) => sum + (mod.quantity || 0),
          0
        );
    
        if (group.isRequired) {
          // 기본값: minRequired가 null이면 0, maxAllowed가 null이면 무제한으로 처리
          const minRequired = group.minRequired !== null ? group.minRequired : 0;
          const maxAllowed = group.maxAllowed !== null ? group.maxAllowed : Infinity;
    
          if (currentGroupQuantity < minRequired || currentGroupQuantity > maxAllowed) {
            return false;
          }
        }
  
          // 재귀적으로 하위 modifierGroup 체크: IModifier 내의 modifiers는 IModifierGroup[]
        for (const mod of group.modifiers) {
          if (mod.modifiers && mod.modifiers.length > 0) {
            if (!checkAllRequiredSatisfied(mod.modifiers)) {
              return false;
            }
          }
        }
      }
      return true;
    };
  
    // 최상위 modifierGroups부터 조건 검사 시작
    const allRequiredSatisfied = checkAllRequiredSatisfied(recommendItem?.modifierGroups || []);
    setSelectRequired(allRequiredSatisfied);
  }, [recommendItem, setSelectRequired]);

  const toggleNestedModifier = (modifierPath: string) => {
    // setItemDetail(recommendItem.modifierGroups!.map((group, idx) => ({
    //   ...group,
    //     modifiers: toggleModifier(group.modifiers, modifierPath),
    // })))
    // setModifierGroups((prevGroups: any) =>
    //   prevGroups.map((group: any) => ({
    //     ...group,
    //     modifiers: toggleModifier(group.modifiers, modifierPath),
    //   }))
    // );
  };
  
  const toggleModifier = (modifier: IModifier) => {
    const dummyEvent = {
      stopPropagation: () => {},
      preventDefault: () => {},
    };
    if (modifier.quantity && modifier.quantity > 0) {
      // ✅ 수량이 0보다 크면 완전 초기화
      const updatedGroups = recommendItem.modifierGroups!.map(group =>
        group.modifiers.some(m => m.path === modifier.path)
          ? {
              ...group,
              modifiers: group.modifiers.map(m =>
                m.path === modifier.path ? resetModifier(m) : m
              ),
            }
          : {
              ...group,
              modifiers: group.modifiers.map(m =>
                m.modifiers
                  ? {
                      ...m,
                      modifiers: m.modifiers.map(subGroup =>
                        subGroup.modifiers.some(sm => sm.path === modifier.path)
                          ? {
                              ...subGroup,
                              modifiers: subGroup.modifiers.map(sm =>
                                sm.path === modifier.path ? resetModifier(sm) : sm
                              ),
                            }
                          : subGroup
                      ),
                    }
                  : m
              ),
            }
      );

      recommendItem.modifierGroups = updatedGroups;
      setRecommendItem({ ...recommendItem });

      const checkedModifiers = getCheckedModifiers(updatedGroups);
      if (preRecommendOrder) {
        const updatedOrder = {
          ...preRecommendOrder,
          orderModifiers: checkedModifiers,
          hasModifier: checkedModifiers.length > 0
        };
        setPreRecommendOrder(updatedOrder);
      }
    } else {
      // 선택되어 있지 않다면, 선택 (quantity 1로)
      increaseNumber(modifier.path, dummyEvent);
    }
  };

  const loadNestModifier = async (modifierId: number, parentPath: string) => {
    // Add check for storeId before making the API call
    if (storeId === undefined) {
      logger.error("Store ID is undefined, cannot load nested modifier.");
      // Optionally, show a user-facing error message here
      return; 
    }

    try {
      const res = await getNestModifierGroup(modifierId, storeId);
      logger.debug(res)
      const updatedGroups =  updateNestedModifier(recommendItem.modifierGroups!, modifierId, res.data, parentPath)
      recommendItem.modifierGroups = updatedGroups
      setRecommendItem({...recommendItem})
      // setModifierGroups((prevGroups: any) => {
      //   const updatedGroups =  updateNestedModifier(prevGroups, modifierId, res.data, parentPath)
      //   logger.debug("Nested modifier loaded successfully:", updatedGroups);
      //   return updatedGroups;
      // });
  
    } catch (error) {
      logger.error("Failed to load nested modifier:", error);
    }
  }
  const generatePaths = (groups: IModifierGroup[], parentPath: string): IModifierGroup[] => {
    return groups.map((group, groupIndex) => {
      const groupPath = `${parentPath}/g-${group.id}-${groupIndex}`;
      return {
        ...group,
        path: groupPath, // Add the path to the group
        modifiers: group.modifiers.map((modifier, modifierIndex) => ({
          ...modifier,
          path: `${groupPath}/m-${modifier.id}-${modifierIndex}`, // Add the path to the modifier
          modifiers: modifier.modifiers
            ? generatePaths(modifier.modifiers, `${groupPath}/m-${modifier.id}-${modifierIndex}`)
            : [],
        })),
      };
    });
  };

  const updateNestedModifier = (groups:  IModifierGroup[], modifierId: number, nestedGroups: IModifierGroup[], parentPath: string): IModifierGroup[] => {
    // const checkExistingGroup = (
    //   groupTree: IModifierGroup[],
    //   groupId: number
    // ): boolean => {
    //   return groupTree.some((group) => {
    //     if (group.id === groupId) {
    //       toast.error("There's a problem with your modifier settings. Infinite modifiers are not supported. ")
    //       return true;
    //     }
    //     return group.modifiers && checkExistingGroup(group.modifiers, groupId);
    //   });
    // };
    const nestedGroupsWithPaths = generatePaths(nestedGroups, `${parentPath}`);
    return groups.map((group: any, groupIndex: number) => {
      return {
        ...group,
        modifiers: group.modifiers.map((modifier: any) => {
          if (modifier.path === parentPath) {
            // Update the specific modifier with nested data
            // const filteredNestedGroups = nestedGroups.filter(
            //   (nestedGroup) => !checkExistingGroup(groups, nestedGroup.id)
            // );
   
            return {
              ...modifier,
              // hasNestedModifierGroups: false,
              modifiers: nestedGroupsWithPaths,
            };
          }
          if (modifier.modifiers) {
            // Recursively update nested modifiers
            return {
              ...modifier,
              modifiers: updateNestedModifier(
                modifier.modifiers,
                modifierId,
                nestedGroups,
                `${parentPath}`
              ),
            };
          }
          return modifier;
        }),
      };
    });
  };

  const modifierGuide = (min: any, max: any) => {
    let text = ''
    if(min && max) {
      text += `Min. ${min} & Max. ${max}`
    } else if(min) {
      text += `Min. ${min}`
    } else if(max) {
      text += `Max. ${max}`
    }
    return text
  }

  const getCheckedModifiers = (groups: IModifierGroup[]): IOrderModifiers[] => {
    return groups.flatMap((group: IModifierGroup) => {
      // Calculate the cumulative quantity for the current group
      const modifierGroupCount = group.modifiers.reduce(
        (sum: number, modifier: IModifier) => sum + (modifier.quantity || 0),
        0
      );
  
      return group.modifiers
        .filter((modifier: IModifier) => modifier.quantity !== null && modifier.quantity > 0)
        .map((modifier: IModifier) => {
          return {
            modifierGroupId: group.id, // Group ID
            modifierGroupName: group.modifierGroupName, // Group Name
            modifierId: modifier.originalId? modifier.originalId: modifier.id, // Modifier ID
            modifierName: modifier.modifierName, // Modifier Name
            modifierPrice: modifier.modifierPrice, // Modifier Price
            quantity: modifier.quantity!, // Modifier's selected quantity
            isRequired: group.isRequired,
            path: group.path,
            maxAllowedGroup: group.maxAllowed,
            minRequiredGroup: group.minRequired,
            modifierGroupCount: modifierGroupCount, // Total quantity selected in this group
            hasNestedModifierGroups: modifier.hasNestedModifierGroups,
            orderModifiers: modifier.modifiers
              ? getCheckedModifiers(modifier.modifiers as IModifierGroup[])
              : [],
          };
        });
    });
  };

  const debouncedCheckedModifierPrice = debounce((priceData) => {
    checkedModifierPrice(priceData);
  }, 300);

  const generateUniqueId = (baseId: number): number => {
    // baseId에 타임스탬프와 랜덤 값을 붙여 고유한 숫자로 생성 (예시)
    return Number(`${baseId}${Date.now()}${Math.floor(Math.random() * 1000)}`);
  };
  
  const generateUniqueSuffix = (): string => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
  };

  // Optimized cloning function without cloneDeep - Resets nested state
  function cloneModifier(modifier: IModifier, newPathPrefix: string): IModifier {
    const newModifierPath = `${newPathPrefix}/m-${modifier.id}-${generateUniqueSuffix()}`;
    const newModifier: IModifier = {
      ...modifier, // Shallow copy base properties
      originalId: modifier.originalId ?? modifier.id,
      id: generateUniqueId(modifier.originalId ?? modifier.id),
      path: newModifierPath,
      quantity: 0, // Reset quantity for nested clones
      isExpanded: false, // Reset expansion for nested clones
      // Recursively clone modifier groups, passing the new modifier path
      modifiers: modifier.modifiers
        ? modifier.modifiers.map(group => cloneModifierGroup(group, newModifierPath))
        : [],
    };
    return newModifier;
  }

  // Optimized cloning function without cloneDeep
  function cloneModifierGroup(modifierGroup: IModifierGroup, newPathPrefix: string): IModifierGroup {
    const newGroupPath = `${newPathPrefix}/g-${modifierGroup.id}-${generateUniqueSuffix()}`;
    const newGroup: IModifierGroup = {
      ...modifierGroup, // Shallow copy base properties
      path: newGroupPath,
      // Recursively clone modifiers, passing the new group path
      modifiers: modifierGroup.modifiers
        ? modifierGroup.modifiers.map(mod => cloneModifier(mod, newGroupPath))
        : [],
    };
    return newGroup;
  }

  const increaseModifierByPath = (
    groups: IModifierGroup[],
    path: string,
    updateFn: (modifier: IModifier, group: IModifierGroup) => IModifier[]
  ): IModifierGroup[] => {
    return groups.map((group) => {
      const updatedModifiers = group.modifiers.reduce((acc: IModifier[], modifier: IModifier) => {
        if (modifier.path === path) {
          const updates = updateFn(modifier, group);
          return acc.concat(updates);
        } else if (modifier.modifiers && Array.isArray(modifier.modifiers)) {
          return acc.concat({
            ...modifier,
            modifiers: increaseModifierByPath(modifier.modifiers as IModifierGroup[], path, updateFn),
          });
        } else {
          acc.push(modifier);
          return acc;
        }
      }, []);
      return { ...group, modifiers: updatedModifiers };
    });
  };

  const updateFn = (modifier: IModifier, group: IModifierGroup): IModifier[] => {
    const currentGroupQuantity = group.modifiers.reduce(
      (sum: number, mod: IModifier) => sum + (mod.quantity || 0),
      0
    );

    // Check if increasing this modifier exceeds its own maxAllowed
    if (modifier.maxAllowed !== null && (modifier.quantity && modifier.quantity >= modifier.maxAllowed)) {
      toast.error(`You can select up to ${modifier.maxAllowed} of this item.`);
      return [modifier]; // Do not update
    }

    // Check if increasing this modifier exceeds the group's maxAllowed
    if (group.maxAllowed !== null && currentGroupQuantity >= group.maxAllowed) {
      toast.error(`You can choose up to ${group.maxAllowed} options only.`);
      return [modifier]; // Do not update
    }

    if ( modifier.hasNestedModifierGroups && modifier.modifiers.length === 0) {
      loadNestModifier(modifier.id, modifier.path);
    }

    // 원본 modifier는 항상 quantity 1로 세팅
    if(!modifier.hasNestedModifierGroups) {
      const baseModifier: IModifier = { 
        ...modifier, 
        quantity: (modifier.quantity||0) + 1, 
        isExpanded: true 
      };
      return [baseModifier];
    }
    const baseModifier: IModifier = { 
      ...modifier, 
      quantity: 1, 
      isExpanded: true 
    };

    if ((modifier.quantity || 0) === 0 ) {
      return [baseModifier];
    }

    // Create duplicate using optimized cloning - resets nested state
    const newDuplicatePathPrefix = modifier.path + '-' + generateUniqueSuffix();
    const duplicateModifier: IModifier = {
      ...modifier, // Shallow copy original modifier properties
      id: generateUniqueId(modifier.originalId ?? modifier.id),
      originalId: modifier.originalId ?? modifier.id,
      path: newDuplicatePathPrefix,
      quantity: 1, // The new duplicate instance starts with quantity 1
      isExpanded: true, // Assume the new instance is expanded initially
      // Clone nested modifiers using the optimized function which resets their state
      modifiers: modifier.modifiers
        ? modifier.modifiers.map((nestedGroup) => cloneModifierGroup(nestedGroup, newDuplicatePathPrefix))
        : [],
    };

    return [baseModifier, duplicateModifier];
  };

  const increaseNumber = (modifierPath: string, e: any) => {
    e.stopPropagation();
    e.preventDefault();
  
    const updatedGroups = increaseModifierByPath(recommendItem.modifierGroups!, modifierPath, updateFn);
    const checkedModifiers = getCheckedModifiers(updatedGroups);
    
    // preRecommendOrder 업데이트
    if (preRecommendOrder) {
      preRecommendOrder.orderModifiers = checkedModifiers.length > 0 ? checkedModifiers : [];
      setPreRecommendOrder({...preRecommendOrder});
    }

    // recommendItem 업데이트
    // const updatedRecommendItem = {
    //   ...recommendItem,
    //   modifierGroups: updatedGroups,
    //   hasModifier: checkedModifiers.length > 0
    // };
    recommendItem.modifierGroups = updatedGroups;
    setRecommendItem({...recommendItem});
  };

  function resetModifier(mod: IModifier): IModifier {
    return {
      ...mod,
      quantity: 0,
      isExpanded: false,
      // modifier.modifiers는 IModifierGroup[] 타입이므로 각 그룹 내의 modifier들을 resetModifier로 재귀 초기화
      modifiers: []
      // modifiers: mod.modifiers
      //   ? mod.modifiers.map((group) => resetModifierGroup(group))
      //   : mod.modifiers,
    };
  }
  
  function resetModifierGroup(group: IModifierGroup): IModifierGroup {
    return {
      ...group,
      modifiers: group.modifiers ? group.modifiers.map(resetModifier) : group.modifiers,
    };
  }

  const decreaseModifierByPath = (
    groups: IModifierGroup[],
    targetPath: string
  ): IModifierGroup[] => {
    return groups.map((group) => {
      if (group.modifiers.some(mod => mod.path === targetPath)) {
        const targetModifier = group.modifiers.find(mod => mod.path === targetPath);
        return { ...group, modifiers: updateFnForDecrease(group, targetModifier!) };
      } else {
        // targetPath를 가진 modifier가 없다면,
        // 중첩된 modifier 그룹이 있을 경우 재귀적으로 업데이트합니다.
        const updatedModifiers = group.modifiers.map((mod) => {
          if (mod.modifiers && mod.modifiers.length > 0) {
            return {
              ...mod,
              modifiers: decreaseModifierByPath(mod.modifiers, targetPath)
            };
          }
          return mod;
        });
        return { ...group, modifiers: updatedModifiers };
      }
    });
  };

  const updateFnForDecrease = (
    group: IModifierGroup,
    targetModifier: IModifier
  ): IModifier[] => {
    const baseId = getBaseId(targetModifier);
    // 동일 옵션(기본 id가 같은) modifier들을 찾음
    const matchingModifiers = group.modifiers.filter(
      mod => getBaseId(mod) === baseId
    );
    if (matchingModifiers.length === 0) {
      return group.modifiers;
    }
    
    let newModifiers: IModifier[] = [];
    if (matchingModifiers.length > 1) {
      // duplicate modifier(복제본, originalId가 있는)가 있다면 우선 복제본 중 마지막 것을 제거
      const duplicateModifiers = matchingModifiers.filter(
        mod => mod.originalId !== undefined
      );
      if (duplicateModifiers.length > 0) {
        newModifiers = group.modifiers.filter(
          mod => mod !== duplicateModifiers[duplicateModifiers.length - 1]
        );
      } else {
        // 복제본이 없으면, 마지막 modifier(원본)을 제거 (이 경우는 드물게 발생)
        newModifiers = group.modifiers.filter(
          mod => mod !== matchingModifiers[matchingModifiers.length - 1]
        );
      }
      // 삭제 후 남은 동일 옵션 modifier들의 수량 표시(selectedCount 등)를 업데이트
      const remaining = newModifiers.filter(mod => getBaseId(mod) === baseId);
      if (remaining.length === 1 && remaining[0].originalId !== undefined) {
        // 복제본만 남은 경우, 해당 복제 modifier를 원본으로 승격
        const promoted = {
          ...remaining[0],
          id: remaining[0].originalId,
          path: remaining[0].originalPath ? remaining[0].originalPath : remaining[0].path,
        };
        newModifiers = newModifiers.map(mod =>
          getBaseId(mod) === baseId ? promoted : mod
        );
      }
    } else if (matchingModifiers.length === 1) {
      const target = matchingModifiers[0];
      if ((target.quantity ?? 0) > 1) {
        // ✅ 수량 2 이상이면 수량 -1
        newModifiers = group.modifiers.map(mod =>
          getBaseId(mod) === baseId
            ? { ...mod, quantity: (mod.quantity ?? 0) - 1 }
            : mod
        );
      } else {
        // ✅ 수량 1이면 초기화 및 하위 modifiers 제거
        newModifiers = group.modifiers.map(mod =>
          getBaseId(mod) === baseId
            ? resetModifier(mod)
            : mod
        );
      }
    }
    return newModifiers;
  };

  const decreaseNumber = (modifierPath: string, e: any) => {
    e.stopPropagation();
    e.preventDefault();
    
    const updatedGroups = decreaseModifierByPath(recommendItem.modifierGroups!, modifierPath);
    const checkedModifiers = getCheckedModifiers(updatedGroups);

    // if (preRecommendOrder) {
    //   const updatedOrder = {
    //     ...preRecommendOrder,
    //     orderModifiers: checkedModifiers,
    //     hasModifier: checkedModifiers.length > 0
    //   };
    //   setPreRecommendOrder(updatedOrder);
    // }
    if (preRecommendOrder) {
      if (checkedModifiers.length > 0) {
        preRecommendOrder.orderModifiers = checkedModifiers;
      } else {
        preRecommendOrder.orderModifiers = [];
      }
      setPreRecommendOrder({...preRecommendOrder})
    }

    recommendItem.modifierGroups = updatedGroups;
    setRecommendItem({...recommendItem});
  };

  const groupState = (isRequire: boolean, groupPath: string) => {
    // Recursive function to find the modifier group by its ID and calculate state
    const findGroupAndState = (groups: IModifierGroup[]): any => {
      for (const group of groups) {
        if (group.path === groupPath) {
          // Calculate quantities and requirements
          const currentGroupQuantity = group.modifiers.reduce(
            (sum: number, mod: any) => sum + (mod.quantity || 0),
            0
          );
  
          let satisfiesMinRequirement =
            group.minRequired !== null &&
            currentGroupQuantity >= group.minRequired;
  
          const satisfiesMaxRequirement =
            group.maxAllowed === null ||
            currentGroupQuantity <= group.maxAllowed;
  
          return { satisfiesMinRequirement, satisfiesMaxRequirement };
        }
  
        for (const modifier of group.modifiers) {
          if (modifier.modifiers && modifier.modifiers.length > 0) {
            const nestedResult = findGroupAndState(modifier.modifiers);
            if (nestedResult) {
              return nestedResult;
            }
          }
        }
      }
      return null;
    };
  
    const groupStateResult = findGroupAndState(recommendItem.modifierGroups!);
    if (!groupStateResult) {
      return null; // Group not found
    }
  
    const { satisfiesMinRequirement, satisfiesMaxRequirement } = groupStateResult;
  
    // Render the appropriate state based on requirements
    if (isRequire) {
      if (satisfiesMinRequirement && satisfiesMaxRequirement) {
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '10.0rem',
              height: '2.4rem',
              padding: '.2rem .9rem',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '3.0rem',
              background: '#66C03A',
            }}
          >
            <img style={{width: '1.4rem', height: '1.4rem'}}
              src={`${process.env.PUBLIC_URL}/assets/images/done.svg`}
              alt="done"
            />
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: 'normal',
                color: '#fff',
                ml: '.1rem',
              }}
            >
              Required
            </Typography>
          </Box>
        );
      } else {
        // (b) 필수 but min/max 불충족 => 빨간색 + warning.svg
        return (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '10.0rem',
              height: '2.4rem',
              padding: '.2rem .9rem',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '3.0rem',
              background: '#F72E13',
            }}
          >
            <img style={{width: '1.4rem', height: '1.4rem'}}
              src={`${process.env.PUBLIC_URL}/assets/images/warning.svg`}
              alt="warning"
            />
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: 'normal',
                color: '#fff',
                ml: '.1rem',
              }}
            >
              Required
            </Typography>
          </Box>
        );
      }
    } else {
      // (c) Optional 그룹 => 주황색 배지
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            width: '8.1rem',
            height: '2.4rem',
            padding: '.2rem .9rem',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '3.0rem',
            background: '#FF8E0A',
          }}
        >
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: 'normal',
              color: '#fff',
            }}
          >
            Optional
          </Typography>
        </Box>
      );
    }
  };

  const renderModifierGroup = (
    modifierGroups: IModifierGroup[],
    level: number
  ) => {
    // Ensure modifierGroups is always an array
    const groups = Array.isArray(modifierGroups) ? modifierGroups : [];

    return (
      <Box
        sx={{
          alignItems: "center",
          justifyContent: "flex-start",
          pl: `${level-1 * 7}rem`
        }}
      >
        {groups.map((group, groupIdx) => (
          // Add key to the outermost element returned by map
          <React.Fragment key={`group-${group.id}-${groupIdx}`}>
            <Box
              id={`header-${groupIdx + 1}`}
              sx={[
                { background: '#fff', 
                  margin: "0rem !important",
                },
              ]}
            >
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  p: "1.0rem 2.0rem",
                  height: "9.0rem",
                  background: '#fff',
                  mb: '1.0rem',
                  border: '1px solid #999',
                  borderRadius: '1.0rem'
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "flex-end",
                    flex:1 ,
                  }}
                >
                  {groupState(group.isRequired, group.path)}
                  <Typography
                    sx={{
                      fontSize: "2.0rem",
                      fontStyle: "normal",
                      fontWeight: "500",
                      ml: ".6rem",
                      textWrap: "nowrap",
                      textAlign: "end",
                    }}
                  >
                    {modifierGuide(group.minRequired, group.maxAllowed)}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    height: "5.0rem",
                    display: "flex",
                    textAlign: "start",
                    alignItems: "center",
                    fontSize: "2.0rem",
                    fontWeight: "600",
                    letterSpacing: "-.022rem",
                  }}
                >
                   {t(`${storeId}:optionGroupNames.${group.id}.${currentLng}`)}
                  {/* {group.modifierGroupName} */}
                </Typography>
              </Stack>
              <Box sx={{ display: "grid", p: "0rem 0rem 1.0rem 0rem", gap: ".5rem"}}>
                {group.modifiers.map((modifier, modifierIdx) => (
                  <ModifierCard
                    // Add key to ModifierCard, using path if available and unique, otherwise fallback
                    key={modifier.path || `mod-${modifier.id}-${modifierIdx}`}
                    modifier={modifier}
                    modifierIdx={modifierIdx}
                    level={level}
                  />
                ))}
              </Box>
            </Box>
          </React.Fragment>
        ))}
      </Box>
    );
  };
  

  const getBaseId = (modifier: IModifier): number =>
    modifier.originalId !== undefined ? modifier.originalId : modifier.id;
  
  // function groupModifiersByBaseId(modifiers: IModifier[]): { baseId: number; modifiers: IModifier[] }[] {
  //   const groupsMap = new Map<number, IModifier[]>();
  //   modifiers.forEach((mod) => {
  //     const baseId = getBaseId(mod);
  //     if (!groupsMap.has(baseId)) {
  //       groupsMap.set(baseId, []);
  //     }
  //     groupsMap.get(baseId)!.push(mod);
  //   });
  //   return Array.from(groupsMap.entries()).map(([baseId, mods]) => ({ baseId, modifiers: mods }));
  // }
  
  const ModifierCard = React.memo((props: { modifier: any; modifierIdx: any; level: number}) => {
    const {modifier, modifierIdx, level} = props;
    const dummyEvent = { stopPropagation: () => {}, preventDefault: () => {} };
    return (
      <>
      <Box
        key={modifierIdx}
        sx={{
          position: "relative",
          // padding: { md: "10rem 0rem 0rem 10rem", lg: "26rem 43rem" },
          borderRadius: ".5rem",
          // border:   modifier.quantity! > 0
          //     ? "1rem solid #F72E13"
          //     : "1rem solid #E9E9E9",
          background: "#f5f5f5",
          ...(modifier.isSoldout && {
            backgroundColor: "rgba(0, 0, 0, 0.1)", // Dim effect
          }),
          pointerEvents: modifier.isSoldout ? "none" : "auto",
        }}
        onClick={(e) => {
          if (!modifier.isSoldout) {
            e.stopPropagation();
            toggleModifier(modifier!);
          }
        }}
      >
        {modifier.isSoldout && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent overlay
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: "1.8rem",
              fontWeight: "bold",
              borderRadius: ".5rem", // Match parent border-radius
              zIndex: 1,
            }}
          >
            SOLD OUT
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            opacity: modifier.isSoldout ? 0.6 : 1,
            p: '1.0rem',
          }}
        >
          {modifier.hasNestedModifierGroups && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                mr: '.2rem',
              }}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   toggleNestedModifier(modifier.path);
              // }}
            >
              <ExpandMore
                sx={{
                  color: modifier.quantity! > 0 ? "#F72E13" : "#000",
                  fontSize: "4.0rem",
                  transform: modifier.isExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </Box>
          )}
          <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <Typography
              sx={{
                textAlign: "left",
                fontSize:  "2rem",
                fontStyle: "normal",
                fontWeight: modifier.quantity! > 0 ? "600":"500",
                letterSpacing: "-.022rem",
                display: "-webkit-box",
                overflow: "hidden",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 3,
                color: modifier.quantity! > 0 ? "#F72E13" : "#000"
              }}
            >
               {t(`${storeId}:optionNames.${modifier.originalId ?? modifier.id}.${currentLng}`)}
              {/* {modifier.modifierName} */}
            </Typography>
            <Typography
              sx={{
                textAlign: "left",
                fontSize: "1.8rem",
                fontStyle: "normal",
                fontWeight: "500",
                color: modifier.quantity! > 0 ? "#F72E13" : "#000"
              }}
            >
              {" "}
              +${(modifier.modifierPrice / 100).toFixed(2)}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Typography sx={{ fontSize: '1.6rem', mr: "1.0rem" , color: modifier.quantity! > 0 ? "#F72E13" : "#000"}}>
              {modifierGuide(null, modifier.maxAllowed)}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                borderRadius: '3.0rem',
                padding: '1.0rem 2.0rem',
                width: '17.0rem',
                mr: '0.5rem',
                // border: '3rem solid',
                // borderColor: modifier.quantity! > 0 ? "#F72E13" : "#000",
                gap: ".5rem",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="touch-area" onClick={() => {
                    if (!modifier.isSoldout) {
                      decreaseNumber(modifier.path, dummyEvent);
                    }
                  }}>
                <MinusIcon
                  fill={
                    (modifier.quantity ?? 0) > 0 ? "#F72E13" : "#000"
                  }
                  onClick={() => {
                    if (!modifier.isSoldout) {
                    }
                  }}
                />
              </div>
              <Typography
                sx={{
                  width: "5.0rem",
                  textAlign: "center",
                  fontSize: "2.4rem",
                  fontWeight: "600",
                  color:
                    (modifier.quantity ?? 0) > 0 ? "#F72E13" : "#000",
                }}
              >
                {modifier.quantity || 0}
              </Typography>
              <div className="touch-area" onClick={() => {
                    if (!modifier.isSoldout) {
                      increaseNumber(modifier.path, dummyEvent);
                    }
                  }}>
                <AddIcon
                  fill={
                    (modifier.quantity ?? 0) > 0 ? "#F72E13" : "#000"
                  }
                  onClick={()=>{}}
                />
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
      {modifier.hasNestedModifierGroups && modifier.isExpanded && modifier.modifiers && modifier.modifiers.length !== 0 && (
        <Box sx={{ position: 'relative'}}>
          <Box sx={{ px: '.1rem', pt: '0rem', flex: 1, display: 'flex', flexDirection: 'row'}}>
            {/* <TurnLeft sx={{fontSize: '30rem', transform: "rotate(180deg)"}} /> */}
            <Box sx={{flex: 1}}>
              {renderModifierGroup(modifier.modifiers, level+1)}
            </Box>
          </Box>
        </Box>
      )}
      </>
    )
  });

  return (
    <>
      <List sx={{ p: 0}}>
        {renderModifierGroup(recommendItem?.modifierGroups!, 1)}
      </List>
    </>
  );
};

export default Modifier;
